import { all, call, put, takeLatest, debounce } from "redux-saga/effects";
import earningsApi from "api/earnings";
import invoiceApi from "api/invoice";
import * as act from "store/actions/earnings";

function* getTotalEarningSaga({ cb }) {
  try {
    const data = yield call(earningsApi.getTotalEarning);
    yield put(act.setTotalEarning(data));
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

function* getAgencyEarningsSaga({ agencyId, query, cb }) {
  try {
    const data = yield call(earningsApi.getAgencyEarnings, agencyId, query);
    yield put(act.setAgencyEarnings(data));
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

function* getVendorEarningsSaga({ vendorId, query, cb }) {
  try {
    const data = yield call(earningsApi.getVendorEarnings, vendorId, query);
    yield put(act.setVendorEarnings(data));
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

function* getPosForInvoiceSaga({ query, isLoadMore, cb }) {
  try {
    const data = yield call(invoiceApi.listPOsForInvoiceCreation, query);

    if (isLoadMore) {
      yield put(act.setMorePosForInvoice(data));
    } else {
      yield put(act.setPosForInvoice(data));
    }
    cb?.(true, data);
  } catch (error) {
    cb?.(false, error);
  }
}

function* submitInvoiceRequestSaga({ payload, cb }) {
  try {
    yield call(invoiceApi.submitInvoiceGroup, payload);
    cb?.(true);
  } catch (error) {
    cb?.(false, error);
  }
}

export function* earningsSaga() {
  yield all([
    takeLatest(act.VM_GET_TOTAL_EARNING, getTotalEarningSaga),
    takeLatest(act.VM_GET_AGENCY_EARNINGS, getAgencyEarningsSaga),
    takeLatest(act.VM_GET_VENDOR_EARNINGS, getVendorEarningsSaga),
    takeLatest(act.VM_GET_POS_FOR_INVOICE, getPosForInvoiceSaga),
    debounce(500, act.VM_GET_DEBOUNCE_POS_FOR_INVOICE, getPosForInvoiceSaga),
    takeLatest(act.VM_SUBMIT_INVOICE_REQUEST, submitInvoiceRequestSaga),
  ]);
}
